const adminRoutes = {
  adminDashboard: {
    path: '/dashboard/admin'
  },
  planRequests: {
    path: '/plans/requests'
  },
  adminMore: {
    path: '/more/admin'
  },
  adminMotivationalPhrases: {
    path: '/motivational-phrases'
  },
  playModeration: {
    path: '/admin/play-moderation'
  },
  playMusicAdmin: {
    path: '/admin/play-music'
  },
  playRecoveryAdmin: {
    path: '/admin/play-recovery'
  },
  adminOrganizations: {
    path: '/organizations'
  },
  adminOrganizationDetail: {
    path: '/organizations/:id'
  },
  billingInfo: {
    path: '/billing-info'
  },
  // Gestores del CRM de bienestar (contactos de RRHH). Vive bajo /users porque el admin los
  // administra como usuarios, no como una propiedad escondida de la ficha de la empresa.
  adminOrgManagers: {
    path: '/users/org-managers'
  },
  listAdmin: {
    path: '/users/admins'
  },
  createAdmin: {
    path: '/users/admins/create'
  },
  editAdmin: {
    path: '/users/admins/edit/:id'
  }
};

export default adminRoutes;
